export const Svg_099 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m2.917 52.5 17.5-23.333 14.219 18.958h23.697l-17.5-23.26-9.114 12.104-2.77-3.646L40.832 17.5l26.25 35H2.918Zm8.75-4.375h17.5l-8.75-11.667-8.75 11.667Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.755}
        x2={29.008}
        y1={22.75}
        y2={56.136}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)